
import CourseGroupShow from '../components/course_groups/CourseGroupShow.vue';
import Vue from 'vue';

Vue.component('course-group-show', CourseGroupShow);

export default Vue.extend({});
